export default __webpack_public_path__ + "static/media/hero-mobile-safari-ES.7dd6cd7d.png";